import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmt } from "@/lib/format";

export default function ToplamKasa() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/gencer/toplam").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <div className="py-10 text-center text-[#8C8377]" data-testid="toplam-kasa">Yükleniyor…</div>;
  const block = (title, o, tone) => (
    <div className="bg-white border border-[#E7DECC] rounded-sm p-4" style={{ borderTop: `3px solid ${tone}` }} data-testid={`toplam-${title}`}>
      <div className="kicker mb-3">{title}</div>
      <div className="space-y-1.5 text-sm">
        <div className="flex justify-between"><span className="text-[#8C8377]">Giriş</span><span className="tabular-nums text-[#2F6E4E]">{fmt(o.giris)}</span></div>
        <div className="flex justify-between"><span className="text-[#8C8377]">Çıkış</span><span className="tabular-nums text-[#A63A3A]">{fmt(o.cikis)}</span></div>
        <div className="flex justify-between border-t border-[#EFE7D6] pt-1.5 font-bold"><span>Net</span><span className="tabular-nums">{fmt(o.net)}</span></div>
      </div>
    </div>
  );
  return (
    <div data-testid="toplam-kasa">
      <p className="text-sm text-[#8C8377] mb-4">Tek Hukuk yalnızca Toplam İcra Tahsilatı ile katılır. Gencer: Gelir = P.H.K.K + Peşinat + Senet; Gider = AF + Masraf + Çıkış.</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white border border-[#E7DECC] rounded-sm p-4" style={{ borderTop: "3px solid #B8933F" }} data-testid="toplam-tekhukuk">
          <div className="kicker mb-3">TEK HUKUK KASA</div>
          <div className="text-sm">
            <div className="flex justify-between font-bold"><span>Toplam İcra Tahsilatı</span><span className="tabular-nums text-[#2F6E4E]">{fmt(d.tekhukuk.icra_tahsilat)}</span></div>
          </div>
        </div>
        {block("GENCER KASA", d.gencer, "#B8933F")}
        {block("TOPLAM", d.toplam, "#2F6E4E")}
      </div>
    </div>
  );
}
